import { render } from "./index.vue?vue&type=template&id=fa29517a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=fa29517a&lang=scss"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__